import { ChangeDetectionStrategy, Component, inject, OnDestroy, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DialogService, DynamicDialogComponent, DynamicDialogRef } from 'primeng/dynamicdialog';
import { of } from 'rxjs';
import { PictureGallerySliderComponent } from '@app/core/picture-gallery/components/picture-gallery-slider/picture-gallery-slider.component';
import { IPictureGallerySliderPopupData } from '@app/core/picture-gallery/interfaces/picture-gallery-slider-popup-data.interface';
import { IDevicePicture } from '@app/api/interfaces/device-picture.interface';

@Component({
  selector: 'gc-dialog-picture-gallery-slider',
  templateUrl: './dialog-picture-gallery-slider.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [PictureGallerySliderComponent],
})
export class DialogPictureGallerySliderComponent implements OnDestroy {
  public ref: DynamicDialogRef = inject(DynamicDialogRef);
  public dialogService: DialogService = inject(DialogService);

  public instance: DynamicDialogComponent | undefined;

  public data: IPictureGallerySliderPopupData | undefined;

  public pictures: Signal<IDevicePicture[]>;

  public loading: Signal<boolean>;

  public title: Signal<string>;

  public selected: IDevicePicture | null = null;

  constructor() {
    this.instance = this.dialogService.getInstance(this.ref);
    this.data = this.instance?.data as IPictureGallerySliderPopupData | undefined;

    this.pictures = toSignal(this.data?.list$ ?? of<IDevicePicture[]>([]), { initialValue: [] });
    this.loading = toSignal(this.data?.loading$ ?? of(false), { initialValue: false });
    this.title = toSignal(this.data?.title$ ?? of(''), { initialValue: '' });

    this.selected = this.data?.selectWithActive ?? null;
  }

  public onSave(picture: IDevicePicture): void {
    this.data?.save?.(picture);
  }

  public onClose(): void {
    this.ref.close();
  }

  ngOnDestroy(): void {
    if (this.ref) {
      this.ref.close();
    }
  }
}
